import React from "react";
// import { connect } from "react-redux";
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
  GridPagination,
} from "@mui/x-data-grid";
import CreateRowNested from "./CreateRowNested";
import FilterNestedTable from "./FilterNestedTable";
import NESTED_TABLE_FLOAT_MENU from "../common_trivial/NESTED_TABLE_FLOAT_MENU";

const domain = window.location.host;

// solusi sementara pakai functional component
function CustomToolbarContainerNested(props) {
  return (
    <GridToolbarContainer>
      <div className="row_table">
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <GridToolbarQuickFilter />
          <FilterNestedTable/>
          <CreateRowNested {...props} />
        </div>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: "8px"}}>
          <GridPagination />
          {[
            "localhost:3000",
            "localhost:3003",
            "geo.mapid.io",
            "geo-alpha.mapid.io",
            "geo-beta.mapid.io",
            "dsdajakarta.mapid.io",
            "dsdajakarta-alpha.mapid.io",
            "dsdajakarta-beta.mapid.io",
          ].includes(domain) && <NESTED_TABLE_FLOAT_MENU/>}
        </div>
      </div>
    </GridToolbarContainer>
  );
}

export default CustomToolbarContainerNested;
